const Footer = () => {
  const footerCopyright = document.querySelector(".footer__copyright");

  if (footerCopyright) {
    const footerCopyrightParent = footerCopyright.parentNode;

    if (footerCopyrightParent.tagName !== "LI") {
      const footerCopyrightClone = footerCopyright.cloneNode(true);
      const footerLegalMenu = document.getElementById("menu-legal");
      const liFooterLegalMenu = document.createElement("li");
      try {
        liFooterLegalMenu.appendChild(footerCopyrightClone);
        footerLegalMenu.prepend(liFooterLegalMenu);
        footerCopyright.remove();
      } catch (err) {
        console.error(err.name); // eslint-disable-line
        console.error(err.message); // eslint-disable-line
        console.error(err.stack); // eslint-disable-line
      }
    }
  }
};

export default Footer;
